export class CalendarEvents {
    static create(callTypes) {
        var _a;
        const newEvents = [];
        const firstEvent = CalendarEvents.calendarEvents[0];
        const firstEventStart = new Date(firstEvent.start);
        const now = new Date();
        firstEventStart.setFullYear(now.getFullYear());
        firstEventStart.setMonth(now.getMonth());
        firstEventStart.setDate(now.getDate());
        const offset = firstEventStart.valueOf() - firstEvent.start;
        for (const event of CalendarEvents.calendarEvents) {
            const newEvent = Object.assign({}, event);
            newEvent.start = newEvent.start + offset;
            if (newEvent.end)
                newEvent.end = newEvent.end + offset;
            delete newEvent.callMethods;
            let i = 0;
            for (const callMethod of Object.values((_a = event.callMethods) !== null && _a !== void 0 ? _a : {})) {
                if (!callTypes.includes(callMethod.callType))
                    continue;
                if (!newEvent.callMethods)
                    newEvent.callMethods = {};
                newEvent.callMethods[`a${i++}`] = Object.assign({}, callMethod);
            }
            newEvents.push(newEvent);
        }
        return newEvents;
    }
}
CalendarEvents.calendarEvents = [
    {
        attendees: {
            a0: {
                emailAddress: 'craig.richardson@aveosystems.com',
                name: 'Craig Richardson',
                type: 'required',
            },
            a1: {
                emailAddress: 'steve.joiner@aveosystems.com',
                name: 'Steve Joiner',
                type: 'required',
            },
            a2: {
                emailAddress: 'tom.drewes@aveosystems.com',
                name: 'Tom Drewes',
                type: 'required',
            },
        },
        callMethods: {
            a0: {
                callType: 'pstn',
                dialString: '1234567890',
            },
            a1: {
                callType: 'video',
                dialString: '1234@aveosystems.com',
            },
            a2: {
                callType: 'voip',
                dialString: '1234',
            },
            a3: {
                callType: 'zoom',
                dialString: '123456789',
            },
        },
        description: {
            content: 'Daily stand-up meeting to review status and set priorities.',
            contentType: 'text',
        },
        end: new Date('2020-12-07T09:15:00.000-05:00').valueOf(),
        isAllDay: false,
        location: {
            name: `Steve's Office`,
        },
        organizer: {
            emailAddress: 'steve.joiner@aveosystems.com',
            name: 'Steve Joiner',
        },
        start: new Date('2020-12-07T09:00:00.000-05:00').valueOf(),
        summary: 'Engineering Stand-Up Meeting',
    },
    {
        attendees: {
            a0: {
                emailAddress: 'craig.richardson@aveosystems.com',
                name: 'Craig Richardson',
                type: 'required',
            },
            a1: {
                emailAddress: 'steve.joiner@aveosystems.com',
                name: 'Steve Joiner',
                type: 'required',
            },
            a2: {
                emailAddress: 'tom.drewes@aveosystems.com',
                name: 'Tom Drewes',
                type: 'required',
            },
            a3: {
                emailAddress: 'paul.roberts@aveosystems.com',
                name: 'Paul Roberts',
                type: 'required',
            },
        },
        callMethods: {
            a0: {
                callType: 'pstn',
                dialString: '5678901234',
            },
            a1: {
                callType: 'video',
                dialString: '5678@aveosystems.com',
            },
            a2: {
                callType: 'voip',
                dialString: '5678',
            },
            a3: {
                callType: 'zoom',
                dialString: '567890123',
            },
        },
        description: {
            content: 'Meeting to review and update the long-term roadmap and strategy plan.',
            contentType: 'text',
        },
        end: new Date('2020-12-07T15:00:00.000-05:00').valueOf(),
        isAllDay: false,
        location: {
            name: 'Main Conference Room',
        },
        organizer: {
            emailAddress: 'craig.richardson@aveosystems.com',
            name: 'Craig Richardson',
        },
        start: new Date('2020-12-07T13:00:00.000-05:00').valueOf(),
        summary: 'Roadmap and Strategy Planning',
    },
    {
        attendees: {
            a0: {
                emailAddress: 'craig.richardson@aveosystems.com',
                name: 'Craig Richardson',
                type: 'required',
            },
            a1: {
                emailAddress: 'steve.joiner@aveosystems.com',
                name: 'Steve Joiner',
                type: 'required',
            },
            a2: {
                emailAddress: 'tom.drewes@aveosystems.com',
                name: 'Tom Drewes',
                type: 'required',
            },
        },
        callMethods: {
            a0: {
                callType: 'pstn',
                dialString: '1234567890',
            },
            a1: {
                callType: 'video',
                dialString: '1234@aveosystems.com',
            },
            a2: {
                callType: 'voip',
                dialString: '1234',
            },
            a3: {
                callType: 'zoom',
                dialString: '123456789',
            },
        },
        description: {
            content: 'Daily stand-up meeting to review status and set priorities.',
            contentType: 'text',
        },
        end: new Date('2020-12-08T09:15:00.000-05:00').valueOf(),
        isAllDay: false,
        location: {
            name: `Steve's Office`,
        },
        organizer: {
            emailAddress: 'steve.joiner@aveosystems.com',
            name: 'Steve Joiner',
        },
        start: new Date('2020-12-08T09:00:00.000-05:00').valueOf(),
        summary: 'Engineering Stand-Up Meeting',
    },
    {
        attendees: {
            a0: {
                emailAddress: 'craig.richardson@aveosystems.com',
                name: 'Craig Richardson',
                type: 'required',
            },
            a1: {
                emailAddress: 'steve.joiner@aveosystems.com',
                name: 'Steve Joiner',
                type: 'required',
            },
            a2: {
                emailAddress: 'tom.drewes@aveosystems.com',
                name: 'Tom Drewes',
                type: 'required',
            },
        },
        callMethods: {
            a0: {
                callType: 'pstn',
                dialString: '3456789012',
            },
            a1: {
                callType: 'video',
                dialString: '3456@aveosystems.com',
            },
            a2: {
                callType: 'voip',
                dialString: '3456',
            },
            a3: {
                callType: 'zoom',
                dialString: '345678901',
            },
        },
        description: {
            content: `I have compiled the latest round of user testing results. Let's meet to review the results and discuss user experience updates.`,
            contentType: 'text',
        },
        end: new Date('2020-12-08T11:00:00.000-05:00').valueOf(),
        isAllDay: false,
        location: {
            name: `Tom's Office`,
        },
        organizer: {
            emailAddress: 'tom.drewes@aveosystems.com',
            name: 'Tom Drewes',
        },
        start: new Date('2020-12-08T10:00:00.000-05:00').valueOf(),
        summary: 'Review User Testing Results',
    },
    {
        attendees: {
            a0: {
                emailAddress: 'craig.richardson@aveosystems.com',
                name: 'Craig Richardson',
                type: 'required',
            },
            a1: {
                emailAddress: 'steve.joiner@aveosystems.com',
                name: 'Steve Joiner',
                type: 'required',
            },
            a2: {
                emailAddress: 'tom.drewes@aveosystems.com',
                name: 'Tom Drewes',
                type: 'required',
            },
        },
        callMethods: {
            a0: {
                callType: 'pstn',
                dialString: '1234567890',
            },
            a1: {
                callType: 'video',
                dialString: '1234@aveosystems.com',
            },
            a2: {
                callType: 'voip',
                dialString: '1234',
            },
            a3: {
                callType: 'zoom',
                dialString: '123456789',
            },
        },
        description: {
            content: 'Daily stand-up meeting to review status and set priorities.',
            contentType: 'text',
        },
        end: new Date('2020-12-09T09:15:00.000-05:00').valueOf(),
        isAllDay: false,
        location: {
            name: `Steve's Office`,
        },
        organizer: {
            emailAddress: 'steve.joiner@aveosystems.com',
            name: 'Steve Joiner',
        },
        start: new Date('2020-12-09T09:00:00.000-05:00').valueOf(),
        summary: 'Engineering Stand-Up Meeting',
    },
    {
        attendees: {
            a0: {
                emailAddress: 'craig.richardson@aveosystems.com',
                name: 'Craig Richardson',
                type: 'required',
            },
            a1: {
                emailAddress: 'steve.joiner@aveosystems.com',
                name: 'Steve Joiner',
                type: 'required',
            },
            a2: {
                emailAddress: 'tom.drewes@aveosystems.com',
                name: 'Tom Drewes',
                type: 'required',
            },
            a3: {
                emailAddress: 'paul.roberts@aveosystems.com',
                name: 'Paul Roberts',
                type: 'required',
            },
            a4: {
                emailAddress: 'marion.richardson@aveosystems.com',
                name: 'Marion Richardson',
                type: 'required',
            },
            a5: {
                emailAddress: 'elaine.jones@aveosystems.com',
                name: 'Elaine Jones',
                type: 'required',
            },
        },
        callMethods: {
            a0: {
                callType: 'pstn',
                dialString: '5678901234',
            },
            a1: {
                callType: 'video',
                dialString: '5678@aveosystems.com',
            },
            a2: {
                callType: 'voip',
                dialString: '5678',
            },
            a3: {
                callType: 'zoom',
                dialString: '567890123',
            },
        },
        description: {
            content: 'We will present the latest marketing materials and engagement metrics.',
            contentType: 'text',
        },
        end: new Date('2020-12-09T16:00:00.000-05:00').valueOf(),
        isAllDay: false,
        location: {
            name: 'Main Conference Room',
        },
        organizer: {
            emailAddress: 'marion.richardson@aveosystems.com',
            name: 'Marion Richardson',
        },
        summary: 'Marketing Update',
        start: new Date('2020-12-09T15:00:00.000-05:00').valueOf(),
    },
    {
        attendees: {
            a0: {
                emailAddress: 'craig.richardson@aveosystems.com',
                name: 'Craig Richardson',
                type: 'required',
            },
            a1: {
                emailAddress: 'steve.joiner@aveosystems.com',
                name: 'Steve Joiner',
                type: 'required',
            },
            a2: {
                emailAddress: 'tom.drewes@aveosystems.com',
                name: 'Tom Drewes',
                type: 'required',
            },
        },
        callMethods: {
            a0: {
                callType: 'pstn',
                dialString: '1234567890',
            },
            a1: {
                callType: 'video',
                dialString: '1234@aveosystems.com',
            },
            a2: {
                callType: 'voip',
                dialString: '1234',
            },
            a3: {
                callType: 'zoom',
                dialString: '123456789',
            },
        },
        description: {
            content: 'Daily stand-up meeting to review status and set priorities.',
            contentType: 'text',
        },
        end: new Date('2020-12-10T09:15:00.000-05:00').valueOf(),
        isAllDay: false,
        location: {
            name: `Steve's Office`,
        },
        organizer: {
            emailAddress: 'steve.joiner@aveosystems.com',
            name: 'Steve Joiner',
        },
        start: new Date('2020-12-10T09:00:00.000-05:00').valueOf(),
        summary: 'Engineering Stand-Up Meeting',
    },
    {
        attendees: {
            a0: {
                emailAddress: 'craig.richardson@aveosystems.com',
                name: 'Craig Richardson',
                type: 'required',
            },
            a1: {
                emailAddress: 'steve.joiner@aveosystems.com',
                name: 'Steve Joiner',
                type: 'optional',
            },
            a2: {
                emailAddress: 'tom.drewes@aveosystems.com',
                name: 'Tom Drewes',
                type: 'optional',
            },
            a3: {
                emailAddress: 'paul.roberts@aveosystems.com',
                name: 'Paul Roberts',
                type: 'required',
            },
            a4: {
                emailAddress: 'marion.richardson@aveosystems.com',
                name: 'Marion Richardson',
                type: 'required',
            },
        },
        callMethods: {
            a0: {
                callType: 'pstn',
                dialString: '4567890123',
            },
            a1: {
                callType: 'video',
                dialString: '4567@aveosystems.com',
            },
            a2: {
                callType: 'voip',
                dialString: '4567',
            },
            a3: {
                callType: 'zoom',
                dialString: '456789012',
            },
        },
        description: {
            content: `Let's review the past month's sales and the latest forecast.`,
            contentType: 'text',
        },
        end: new Date('2020-12-10T17:00:00.000-05:00').valueOf(),
        isAllDay: false,
        location: {
            name: `Paul\'s Office`,
        },
        organizer: {
            emailAddress: 'paul.roberts@aveosystems.com',
            name: 'Paul Roberts',
        },
        start: new Date('2020-12-10T16:00:00.000-05:00').valueOf(),
        summary: 'Monthly Sales Forecast',
    },
    {
        attendees: {
            a0: {
                emailAddress: 'craig.richardson@aveosystems.com',
                name: 'Craig Richardson',
                type: 'required',
            },
            a1: {
                emailAddress: 'steve.joiner@aveosystems.com',
                name: 'Steve Joiner',
                type: 'required',
            },
            a2: {
                emailAddress: 'tom.drewes@aveosystems.com',
                name: 'Tom Drewes',
                type: 'required',
            },
        },
        callMethods: {
            a0: {
                callType: 'pstn',
                dialString: '1234567890',
            },
            a1: {
                callType: 'video',
                dialString: '1234@aveosystems.com',
            },
            a2: {
                callType: 'voip',
                dialString: '1234',
            },
            a3: {
                callType: 'zoom',
                dialString: '123456789',
            },
        },
        description: {
            content: 'Daily stand-up meeting to review status and set priorities.',
            contentType: 'text',
        },
        end: new Date('2020-12-11T09:15:00.000-05:00').valueOf(),
        isAllDay: false,
        location: {
            name: `Steve's Office`,
        },
        organizer: {
            emailAddress: 'steve.joiner@aveosystems.com',
            name: 'Steve Joiner',
        },
        start: new Date('2020-12-11T09:00:00.000-05:00').valueOf(),
        summary: 'Engineering Stand-Up Meeting',
    },
    {
        attendees: {
            a0: {
                emailAddress: 'craig.richardson@aveosystems.com',
                name: 'Craig Richardson',
                type: 'required',
            },
            a1: {
                emailAddress: 'steve.joiner@aveosystems.com',
                name: 'Steve Joiner',
                type: 'required',
            },
            a2: {
                emailAddress: 'tom.drewes@aveosystems.com',
                name: 'Tom Drewes',
                type: 'required',
            },
        },
        callMethods: {
            a0: {
                callType: 'pstn',
                dialString: '2345678901',
            },
            a1: {
                callType: 'video',
                dialString: '2345@aveosystems.com',
            },
            a2: {
                callType: 'voip',
                dialString: '2345',
            },
            a3: {
                callType: 'zoom',
                dialString: '234567890',
            },
        },
        description: {
            content: `Let's meet to discuss the past quarter's financial results.`,
            contentType: 'text',
        },
        end: new Date('2020-12-11T14:00:00.000-05:00').valueOf(),
        isAllDay: false,
        location: {
            name: `Craig's Office`,
        },
        organizer: {
            emailAddress: 'craig.richardson@aveosystems.com',
            name: 'Craig Richardson',
        },
        summary: 'Quarterly Finance Review',
        start: new Date('2020-12-11T13:00:00.000-05:00').valueOf(),
    },
];
